import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getExpense } from '#/graphql/queries';
import type { GetExpenseQuery } from '#/graphql/types';

export const GET_EXPENSE = gql(getExpense);

const useExpenseQuery = (id?: string) => {
  const query: QueryResult<GetExpenseQuery> = useQuery(GET_EXPENSE, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useExpenseQuery;
